<template>
    <div>
        <v-select :items="computedCategories" v-model="categoryId" label="Type" hide-details/>
    </div>
</template>

<script>
    export default {
        props: ['value', 'placeholder'],

        data() {
            return {
                categoryId: this.value || null,
                categories: [],
                dialog: false
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.$http.get(`car-categories`).then(response => {
                    this.categories = response.data.data;
                });
            },

            setCreated(newId) {
                this.categoryId = newId;
            }
        },

        watch: {
            categoryId() {
                if (this.categoryId === 'manage') {
                    this.dialog = true;
                    this.categoryId = null;
                    return;
                }
                this.$emit('input', this.categoryId);
            },
            dialog() {
                if (!this.dialog) return this.loadData();
            }
        },

        computed: {
            computedCategories() {
                return [
                    {text: this.placeholder ? this.placeholder : 'Alle', value: null},
                    ...this.categories.map(c => {
                        return {text: `${c.name} (${c.short_name})`, value: c.id}
                    }),
                    //{text: 'Legg til / fjern', value: 'manage'} // TOOD: Re-add when needed, same as customer categories.
                ]
            }
        }
    }
</script>
